import dayjs from 'dayjs';
import {DATA_TYPE_DEFINITIONS} from './index.jsx';

const DEFAULT_GRID_OPTIONS = {
    defaultCsvExportParams: {
      fileName: 'Datagrid_csv'
    },
    defaultExcelExportParams: {
      sheetName: 'DataGrid',
      fileName: 'DataGrid_excel',
      author: 'DataGrid'
    }
  }
  const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
  
export const createDefaultDatagridExportOptions = (datagridName) => {
    const formattedDate = dayjs().format(DEFAULT_DATE_FORMAT);
    const fileName = `${(datagridName ?  datagridName: 'datagrid').replace(/[#$+`%!<> !&*'{}?"=/:\\@]/g, '_').slice(0,62)}_${formattedDate}`
    const sheetName = (datagridName ?  datagridName: 'datagrid').replace(/[\/\\*?\[\]]/g, '_').slice(0,62)
    const gridOptions = {
      ...DEFAULT_GRID_OPTIONS,
      defaultCsvExportParams: {
        ...DEFAULT_GRID_OPTIONS.defaultCsvExportParams,
        fileName: fileName
      },
      defaultExcelExportParams: {
        ...DEFAULT_GRID_OPTIONS.defaultExcelExportParams,
        sheetName: sheetName,
        fileName: fileName
      },
      ...DATA_TYPE_DEFINITIONS
    };
    return gridOptions
};
